//import store from "../../store";
const kontaktRoutes = [
  {
    path: "/Kontakt",
    component: () =>
      import(
        /*webpackChunkName: 'component-homepage' */ "@/pages/Kontakt.vue"
      ),       
  },
];

export default kontaktRoutes;
